// src/pages/controleBar/mesas/MesaConfCad.js
import React, { useState, useEffect } from 'react';

import { useMesaConf } from '../../../contexts/controleBar/mesas/MesaConfContext'; 
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const MesaConfCad = ({ show, onHide }) => {
    const { mesasConf, addMesaConf, updateMesaConf, deleteMesaConf, handleShowMesaConfSearch } = useMesaConf();
    const [mesaConf, setMesaConf] = useState({ id: 0, codigo: '', capacidade: null, ativa: true });
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) handleNovo();
    }, [show]);

    const handleNovo = () => {
        setMesaConf({ id: 0, codigo: '', capacidade: null, ativa: true });
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (!id) {
            showMessage("Selecione uma configuração para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!mesaConf?.id) {
            showMessage("Selecione uma configuração para excluir!");
        } else {
            const confirm = await showYesNo("Deseja excluir a configuração selecionada?");
            if (confirm) {
                await deleteMesaConf(mesaConf.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        if (!mesaConf.codigo) {
            showMessage("Informe o código da configuração!");
            return;
        }

        if (!mesaConf.id) {
            await addMesaConf(mesaConf);
        } else {
            await updateMesaConf(mesaConf);
        }
        handleNovo();
    };

    const handleExit = () => {
        const sel = mesasConf.find(m => m.id === mesaConf.id);
        if (sel) setMesaConf(sel);
        else handleNovo();
    };

    const handleSelectMesaConf = async () => {
        const sel = await handleShowMesaConfSearch();
        if (sel) {
            setMesaConf(sel);
            handleEditar(sel.id);
        } else {
            handleNovo();
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Nova Configuração de Mesa' : 'Alterar Configuração de Mesa'} onHide={onHide} />

            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Id"
                            value={mesaConf.id || ''}
                            onChange={(e) => setMesaConf({ ...mesaConf, id: parseInt(e.target.value) || 0 })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={handleSelectMesaConf}
                        />
                        <Input
                            label="Código"
                            value={mesaConf.codigo || ''}
                            onChange={(e) => setMesaConf({ ...mesaConf, codigo: e.target.value })}
                            autoFocus
                        />
                        <Input
                            label="Capacidade"
                            value={mesaConf.capacidade || ''}
                            onChange={(e) => setMesaConf({ ...mesaConf, capacidade: parseInt(e.target.value) || null })}
                        />
                        <InputCheck
                            label="Ativa"
                            checked={mesaConf.ativa}
                            onChange={(e) => setMesaConf({ ...mesaConf, ativa: e.target.checked })}
                        />
                    </div>
                </form>
            </ModalBody>

            <ModalFooter>
                <ModalActions >
                    <ModalActionButton type='button' className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default MesaConfCad;
